import React from 'react'
import PropTypes from 'prop-types'

const DangerouslySetInnerHtml = props => {
  const { html } = props
  return <span dangerouslySetInnerHTML={{ __html: html }} />
}

DangerouslySetInnerHtml.propTypes = {
  html: PropTypes.string,
}

export default DangerouslySetInnerHtml
